import { Group } from '@mantine/core'
import Image from 'next/image'
import { FC } from 'react'
import PartmentLogo from '../../../../../assets/MainLogo.svg'
import PartmentStaysLogo from '../../../../../assets/PartmentStays_logo.svg'
import { PersonaCardDesign } from './PersonaCard'
import classes from './PersonaCardDesign.module.css'

interface PersonaCardFooterProps {
  cards: {
    title: string
    ctaLink: string
    subtitle: string
  }[]
}

export const PersonaCardFooter: FC<PersonaCardFooterProps> = ({ cards }) => {
  const logoMap: Record<string, any> = {
    Partmentstays: PartmentStaysLogo,
    PartmentStays: PartmentStaysLogo,
    PartmentBlue: PartmentLogo,
  }

  // Partment X is closed. Contentful may still hold its card, so drop it here.
  const personaData = cards
    .filter((card) => card.title !== 'PartmentX')
    .map((card) => ({
      image: logoMap[card.title] ?? null,
      description: card.subtitle,
      cta: 'Learn More',
      ctaUrl: card.ctaLink,
    }))

  return (
    <div className={classes.footerWrapper}>
      <div className={classes.footerContainer}>
        <Image
          src={PartmentLogo}
          alt='Partment Logo'
          width={120}
          height={32}
          className={classes.logo}
        />

        <Group
          align='flex-start'
          style={{
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            gap: '24px',
          }}
        >
          {personaData.map((persona, index) => (
            <PersonaCardDesign key={index} {...persona} />
          ))}
        </Group>
      </div>
    </div>
  )
}
